import React from "react";

export default function UserGuideTileTicketIcon({ size = 47 }) {
  const gid = React.useId().replace(/:/g, "");
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id={gid}
          x1="0"
          y1="0"
          x2="47"
          y2="47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D8EAFF" />
          <stop offset="1" stopColor="#6577F5" />
        </linearGradient>
      </defs>
      <rect width="46.75" height="46.75" rx="23.375" fill={`url(#${gid})`} />
      <path
        d="M19.3117 29.4195L23.3755 26.3766L27.3899 29.4195L25.8684 24.4725L29.9127 21.2921H24.9851L23.3755 16.3645L21.7658 21.2921H16.8577L20.8138 24.4725L19.3117 29.4195ZM12.6086 35.0361C11.5933 35.0361 10.7322 34.6826 10.0253 33.9757C9.31831 33.2688 8.96484 32.4076 8.96484 31.3923V26.6351C8.96484 26.383 9.04181 26.1686 9.19575 25.9917C9.34969 25.8148 9.55271 25.7035 9.80479 25.6577C10.3418 25.5002 10.7944 25.2165 11.1626 24.8065C11.5308 24.3965 11.7148 23.9195 11.7148 23.3755C11.7148 22.8185 11.5308 22.335 11.1626 21.925C10.7944 21.515 10.3418 21.2378 9.80479 21.0933C9.55271 21.0475 9.34969 20.9361 9.19575 20.7593C9.04181 20.5824 8.96484 20.3679 8.96484 20.1158V15.3586C8.96484 14.3433 9.31831 13.4822 10.0253 12.7753C10.7322 12.0683 11.5933 11.7148 12.6086 11.7148H34.1423C35.1576 11.7148 36.0188 12.0683 36.7257 12.7753C37.4326 13.4822 37.7861 14.3433 37.7861 15.3586V20.1353C37.7861 20.3874 37.7091 20.5986 37.5552 20.769C37.4013 20.9394 37.1982 21.0475 36.9462 21.0933C36.4091 21.2378 35.9565 21.515 35.5884 21.925C35.2202 22.335 35.0361 22.8185 35.0361 23.3755C35.0361 23.9195 35.2202 24.3965 35.5884 24.8065C35.9565 25.2165 36.4091 25.5002 36.9462 25.6577C37.1982 25.7035 37.4013 25.8116 37.5552 25.982C37.7091 26.1524 37.7861 26.3636 37.7861 26.6157V31.3923C37.7861 32.4076 37.4326 33.2688 36.7257 33.9757C36.0188 34.6826 35.1576 35.0361 34.1423 35.0361H12.6086Z"
        fill="white"
      />
    </svg>
  );
}
